export const baseUrl = process.env.REACT_APP_BASE_URL;
export const storageUrl = 'https://prorodinki.online/storage'
